import React from "react";
import Section from "../layouts/Section";

const SimpleTags = ({
    title = "인재상",
    description = "KUSRC와 함께할 인재를 찾고있어요",
    features = [
        {
            title: "High Responsibility",
            description: "책임감을 갖고 있는 사람",
            cta: "",
            imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
        },
        {
            title: "Computational Thinking",
            description: "컴퓨팅 사고력",
            cta: "",
            imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
        },
        {
            title: "Positive Thinking",
            description: "긍정적 사고",
            cta: "",
            imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
        },
        {
            title: "Problem Solving",
            description: "문재해결능력",
            cta: "",
            imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
        },
        {
            title: "Continuous Improvement",
            description: "지속적인 개선",
            cta: "",
            imgUrl: "https://cdn-icons-png.flaticon.com/512/4341/4341139.png"
        }
    ]
}) => {
    return (
        <Section width="6xl" space="md">
            <div>
                <div className="flex flex-col justify-between">
                    <h1 className="title-font mb-2 text-h2 font-bold text-gray-900 sm:text-[36px] sm:leading-[46px]">
                        {title}
                    </h1>
                    <p className="text-body leading-relaxed text-gray-500">
                        {description}
                    </p>
                </div>
                <div className="mt-6 mt-10 grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-3">
                    {features.map(feature => (
                        <div
                            key={feature.title}
                            className="flex items-center rounded-lg bg-gray-100 p-6 transition hover:shadow-card-lg"
                        >
                            <svg
                                fill="none"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="3"
                                className="mr-4 h-6 w-6 flex-shrink-0 text-brand"
                                viewBox="0 0 24 24"
                            >
                                <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                                <path d="M22 4L12 14.01l-3-3"></path>
                            </svg>
                            <div>
                                <div className="text-lead font-semibold text-gray-900">
                                    {feature.title}
                                </div>
                                <div className="text-body text-gray-500">
                                    {feature.description}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
};

export default SimpleTags;
